export default "__VITE_ASSET__II354oFK__"